import PropTypes from "prop-types";
import { DirectionalIcon } from "../DirectionalIcon/DirectionalIcon";
import Arrow from "~/content/icons/arrow.svg?react";

/**
 * ArrowIcon component that wraps the Arrow SVG icon in a DirectionalIcon component.
 * It allows for automatic flipping of the icon based on the text direction (LTR/RTL).
 */
export function ArrowIcon({ className }) {
  return (
    <DirectionalIcon>
      <Arrow className={className} />
    </DirectionalIcon>
  );
}

ArrowIcon.propTypes = {
  className: PropTypes.string,
};
